export default __webpack_public_path__ + "static/media/coiffeur-res.6fde8684.svg";